import React from 'react';
import { Aligner } from '@alfa-bank/site-aligner';
import cn from 'classnames';

import type { TRatesTableHeader } from './models';

export const RatesTableHeader = ({
    Text,
    columnNames,
    isMobile = false,
    shortDesktop = false,
    styles,
}: TRatesTableHeader) => {
    const [firstColumnName, ...restColumnNames] = columnNames;
    const columnTextView = shortDesktop && !isMobile ? 'primary-medium' : 'primary-small';

    return (
        <thead>
            <tr className={styles.row}>
                <th className={cn(styles.external, styles.firstColumn)}>
                    <Aligner align="left">
                        <Text
                            kind="caption"
                            styler={{ marginTop: 0, marginBottom: 0 }}
                            view={columnTextView}
                        >
                            {firstColumnName}
                        </Text>
                    </Aligner>
                </th>
                {restColumnNames.map((columnName, i) => {
                    return (
                        <th key={columnName + i} className={cn(styles.external, styles.restColumn)}>
                            <Aligner align="right">
                                <Text
                                    kind="caption"
                                    styler={{ marginTop: 0, marginBottom: 0 }}
                                    view={columnTextView}
                                >
                                    {columnName}
                                </Text>
                            </Aligner>
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
};
